module.exports = __webpack_public_path__ + "img/sj.4004c9d0.svg";